import {Component, OnInit} from '@angular/core';

import {HttpService} from './../../services/HttpService';
import {NotificationService} from './../../services/NotificationService';
import {AppComponent} from '../../app.component'

import {EditUserComponent} from '../../edit-user/edit-user.component';

import {MatDialog} from '@angular/material';

import swal from 'sweetalert2';

declare var $: any;


@Component({
    selector: 'app-extended-table-cmp',
    templateUrl: 'extendedtable.component.html',
    providers: [HttpService, NotificationService]
})

export class ExtendedTableComponent implements OnInit {
    public User_Details: any;
    public allUsers: any = [];
    public actionUser: any;
    public sortValue: string = '';
    public reverse: boolean = false;

    public currentPage = 1;

    // Server-side search term. Sent with every getalluser request so it composes
    // with the existing sort + pagination (the API filters before paginating).
    public searchValue: string = '';
    private searchTimer: any;

    constructor(
        public http: HttpService,
        public app: AppComponent,
        public notification: NotificationService,
        public dialog: MatDialog
    ) {

    }

    ngOnInit() {

        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        try {
            this.getAllUsers();
        } catch (ex) {
            this.app.loading = false;
        }

    }

    editUser(userToEdit) {
        let dialogRef = this.dialog.open(EditUserComponent, {
            width: '100vw',
            data: {userDetails: userToEdit}
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (result.changedUser) {
                    for (var i = 0; i < this.allUsers.length; i++) {
                        if (this.allUsers[i].id == userToEdit.id) {
                            this.allUsers[i] = result.changedUser;
                        }
                    }
                }
            }

        });

    }


    getAllUsers(page = 1) {
        this.app.loading = true;
        this.http.makeRequestPost([`admin/user/getalluser?page=${page}`, {token: this.User_Details.token, search: this.searchValue}])
        .subscribe(
            (response) => {
                this.app.loading = false;
                if (response.data) {
                    if (response.data.data) {
                        // Set the list whatever the count — an empty result (e.g. a
                        // search with no matches) should clear the table, not error.
                        this.allUsers = response.data;
                    } else {
                        this.notification.showNotification('Could not get all users', 'Error', 'error');
                    }

                }
                if (response.error) {
                    this.notification.showNotification('Could not get all users', 'Error', 'error');
                }


            },
            (error) => {
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                this.app.loading = false;
            }
        )
    }

    deleteUserConfirm(userToDelete) {
        this.actionUser = userToDelete;
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to delete this user?',
            type: 'warning',
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            showCancelButton: true,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            confirmButtonText: 'Yes',
            reverseButtons: true,
            buttonsStyling: false
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.http.makeRequestPost(['admin/user/delete', {token: this.User_Details.token, id: userToDelete.id}])
                .subscribe(
                    (response) => {
                        if (response.data) {
                            if (response.data.active == 0) {
                                for (var i = 0; i < this.allUsers.length; i++) {
                                    if (this.allUsers[i].id == userToDelete.id) {
                                        this.allUsers[i] = response.data;
                                    }
                                }
                            } else {
                                this.notification.showNotification('Could not delete the user', 'Error', 'error');
                            }
                        }
                    },
                    (error) => {
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }

        }).catch(swal.noop);
    }


    // deleteUser(data) {
    // 	console.log("delete", data);
    // }
    //
    // editUser(data) {
    // 	console.log("edit", data);
    // }

    loadPage(event) {
        this.currentPage = event;
        this.getAllUsers(event);
    }

    // Debounced handler for the search box so we don't hit the API on every keystroke.
    onSearchInput() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            this.onSearch();
        }, 350);
    }

    // Run the search: reset to page 1 and reload, preserving the active column sort
    // if there is one (so search + sort + pagination all work together).
    onSearch() {
        this.currentPage = 1;
        if (this.sortValue) {
            this.changeSortValue(this.sortValue, !this.reverse, 1);
        } else {
            this.getAllUsers(1);
        }
    }

    clearSearch() {
        if (this.searchValue === '') {
            return;
        }
        this.searchValue = '';
        this.onSearch();
    }

    changeSortValue(column, reverse, page = 1) {
        this.app.loading = true;
        this.http.makeRequestPost([`admin/user/getalluser?page=${page}`,
            {
                token: this.User_Details.token,
                sort_by: column,
                direction: reverse ? -1 : 1,
                search: this.searchValue,
            }])
        .subscribe(
            (response) => {
                this.currentPage = page;
                this.app.loading = false;
                if (response.data) {
                    if (response.data.data) {
                        // Set the list whatever the count — an empty result (e.g. a
                        // search with no matches) should clear the table, not error.
                        this.allUsers = response.data;
                    } else {
                        this.notification.showNotification('Could not get all users', 'Error', 'error');
                    }

                }
                if (response.error) {
                    this.notification.showNotification('Could not get all users', 'Error', 'error');
                }


            },
            (error) => {
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                this.app.loading = false;
            }
        )
    }


}



// WEBPACK FOOTER //
// ./src/app/users/extendedtable/extendedtable.component.ts